import store from 'reducers'

class Events {
    static get id(){
        return store.getState().config.widgetID
    }
    static on(key, cb){
        this.callbacks(key).push(cb)
    }
    static callbacks(key){
        this[`${this.id}-${key}`] = this[`${this.id}-${key}`] || []

        return (
            this[`${this.id}-${key}`]
        )
    }
    static trigger(key, options){
        for(let cb of this.callbacks(key)){
            cb(options)
        }
    }
}



export default Events


// WEBPACK FOOTER //
// ./actions/events.js